import { observable, action, computed } from 'mobx';
import FilmData from './FilmData.js';
// import $ from 'jquery';

class AppState {
  @observable modalIsOpen = false;
  @observable modalIsPlaying = false;

  @observable filmGroupNameFilter = 'all';

  @observable pageYOffset = 0;

  @action updateYOffset(offset) {
    this.pageYOffset = offset;
  }

  @observable height = 0;
  @observable width = 0;

  @action updateWindowDimensions(width, height) {
    this.height = height;
    this.width = width;
  }

  @computed get windowPath() {
    return window.location.pathname;
  }

  @computed get isMobile() {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  // @computed get scrollPosition() {
  // var doc = document.documentElement;
  // var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  // var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
  //   let top = $(document).scrollTop();
  //   return top;
  // }

  @computed get films() {
    return this.filmGroupNameFilter === 'all'
      ? FilmData.films
      : FilmData.films.filter(
          filmGroup => filmGroup.name === this.filmGroupNameFilter,
        );
  }

  @action setFilmGroupNameFilter(name) {
    this.filmGroupNameFilter = name;
  }

  @observable modalPlayerVideo = {
    url: '',
    title: '',
  };

  @action openAndPlay(video) {
    this.modalIsOpen = true;
    this.modalIsPlaying = true;
    this.modalPlayerVideo = video;
  }

  @action toggleModal = () => {
    this.modalIsOpen = !this.modalIsOpen;
  };
}

export default AppState;



// WEBPACK FOOTER //
// ./src/AppState.js